import EmptyTablePlaceholder from './EmptyTablePlaceholder'

export default EmptyTablePlaceholder
